import React, { useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import ResponsiveTabs from "../../../common/ResponsiveTabs";
import { selectPostById } from "../../../redux/slices/postsSlice";
import ByEmail from "./ByEmail";
import InviteInBulk from "./InviteBulk";
import ShareLink from "./ShareLink";

const InviteCandidateModal = ({ open, onClose }) => {
  const { postId } = useParams();
  const [tabValue, setTabValue] = useState("share_link");
  const post = useSelector((state) => selectPostById(state, postId));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          margin: 0,
          width: { xs: "95vw", md: "75vw" },
          height: { xs: "95vh", md: "70vh" },
          overflow: "hidden",
          maxWidth: "none",
          maxHeight: "none",
          p: 2,
          borderRadius: "10px",
        },
      }}
    >
      <DialogTitle>
        <Box
          sx={{
            mb: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">Invite candidates</Typography>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{ border: 1, borderColor: "#999" }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <ResponsiveTabs
          tabData={tabs}
          selectedTab={tabValue}
          onChange={setTabValue}
          fullWidth={false}
        />
      </DialogTitle>
      <DialogContent>
        {tabValue === "share_link" ? (
          <ShareLink post={post} onClose={onClose} />
        ) : tabValue === "bulk" ? (
          <InviteInBulk post={post} onClose={onClose} />
        ) : (
          <ByEmail post={post} onClose={onClose} />
        )}
      </DialogContent>
    </Dialog>
  );
};

const tabs = [
  {
    title: "Share link",
    value: "share_link",
  },
  {
    title: "Import candidates",
    value: "bulk",
  },
  {
    title: "Invite by email",
    value: "email",
  },
];

export default InviteCandidateModal;
